<script type="text/jsx" lang="jsx">
import Add from './add';
import Trial2paid from './trial2paid';
import AddTrial from './addTrial';
import Edit from './edit';
import BuyNow from './buy-now';
import EditDelta from './edit-delta.vue';
import planPropsMixin from '@/plans/mx/plan-props';
import planCommonMixin from '@/plans/EVENT_SAAS_CORE/mixin';
import { isAutoAddable } from '@/plans/ZOOM_MEETING/common/utils';

export default {
  mixins: [planPropsMixin, planCommonMixin],
  render() {
    const context = {...this.$props, ...this.$attrs};
    // FREE TRIAL
    if (this.$context.is.add2trial) return <AddTrial {...context} />;
    if (this.$context.is.add2cart) return <Add {...context} />;
    if (this.$context.is.trial2paid) return <Trial2paid {...context} />;
    if (this.$context.is.edit) {
      if (this.$context.is.addQty && isAutoAddable()) {
        return <EditDelta {...context} />;
      }
      return <Edit {...context} />;
    }
    return <BuyNow {...context} />;
  },
};
</script>
